export default __webpack_public_path__ + "/dist/images/Producers-video.c040aeace6cfc0d00292bcdf96a5f6b7.mp4";